import type { CSSProperties } from 'react';
import { renderMarkdown } from './markdown';

export interface AssistantMarkdownProps {
  /** The assistant's reply exactly as the model wrote it — markdown, never HTML. */
  text: string;
  /**
   * The colour links are drawn in. Validated by `safeColor` (markdown.ts):
   * hex, `rgb()`/`hsl()`, or a bare colour keyword. Anything else — a CSS
   * variable, a Tailwind class name — draws the widget's default blue, so a
   * host that themes with tokens resolves the token first.
   */
  accent?: string;
  className?: string;
  style?: CSSProperties;
}

/**
 * An assistant reply drawn the way the chat widget draws it.
 *
 * Every surface that shows what Ema said renders through THIS component —
 * the widget's own bubbles and the Ema Answers console's Conversations
 * transcript (1.24.0). The console used to carry a renderer of its own, the
 * portal's document renderer, which had no link rule: a reply the visitor
 * saw as "Our pricing" appeared in the transcript as
 * `[Our pricing](https://…/pricing)`. One renderer, one set of rules, one
 * place to fix a rendering bug (and the XSS discipline of markdown.ts is
 * the whole of the defence on the customer sites the widget lives on).
 *
 * A `span`, as the widget has always drawn it: the bubble is the block.
 */
export function AssistantMarkdown({ text, accent, className, style }: AssistantMarkdownProps) {
  return (
    <span
      className={className}
      style={style}
      data-pwe="markdown"
      dangerouslySetInnerHTML={{ __html: renderMarkdown(text, accent ?? '') }}
    />
  );
}
